module.exports = __webpack_public_path__ + "static/media/hopper.a2575330.gif";